if (!customElements.get('sticky-atc-button')) {
  customElements.define(
    'sticky-atc-button',
    class StickyAtcButton extends HTMLElement {
      constructor() {
        super();

        this.originalForm = document.querySelector(`.product-form form[action="${routes.cart_add_url}"]`) || document.querySelector('.product__page form[action="/cart/add"]') || document.querySelector('.product form[action="/cart/add"]') || document.querySelector('form[action="/cart/add.js"]') || document.querySelector('form[action="/cart/add"]');
        if (this.originalForm === null) return console.error('Deployer: No product form found');

        this.originalBtn = this.originalForm.querySelector('button[name="add"]');
        this.stickyButton = null;
        this.onVariantChangeUnsubscriber = undefined;

        this.cloneOriginalButton();
      }

      connectedCallback() {
        this.updateDisplay();

        window.addEventListener('scroll', () => {
          this.updateDisplay();
        });

        if (this.stickyButton) {
          this.stickyButton.addEventListener('click', () => {
            this.submitForm();
          });
        }

        // update when variant changes (works with Broadcast, Prestige, Dawn & co, Impulse)
        if (this.originalForm.querySelector('input[name="id"]') !== null) {
          this.originalForm.querySelector('input[name="id"]').addEventListener('change', () => {
            this.cloneOriginalButton();
          });
        } else {
          if (typeof subscribe === 'function') {
            this.variantChangeSubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => {
              this.cloneOriginalButton();
            });
          } else {
            document.addEventListener('variant:change', () => {
              this.cloneOriginalButton();
            });
          }
        }
      }

      updateDisplay() {
        if (this.originalBtn) {
          var rect = this.originalBtn.getBoundingClientRect();
          var footerRect = document.querySelector('footer').getBoundingClientRect();
          var windowHeight = window.innerHeight;

          // Vérifie si le bouton d'ajout principal est visible
          var isOriginalBtnVisible = rect.bottom > 0 && rect.top < windowHeight;

          // Vérifie si le footer est visible
          var isFooterVisible = footerRect.top < windowHeight && footerRect.bottom > 0;

          if (!isOriginalBtnVisible && !isFooterVisible) {
            this.classList.remove('sticky-atc-button--hidden');
          } else {
            this.classList.add('sticky-atc-button--hidden');
          }
        }
      }

      cloneOriginalButton() {
        const stickyAtcButton = this.originalBtn.cloneNode(true);
        document.querySelector('.sticky-atc-button_container').innerHTML = '';
        document.querySelector('.sticky-atc-button_container').appendChild(stickyAtcButton);
        this.stickyButton = this.querySelector('button[type="submit"]');
        this.connectedCallback();
      }

      submitForm() {
        this.stickyButton.setAttribute('aria-disabled', true);
        if (window.deployerAdapter.loadingClass != null && window.deployerAdapter.loadingSpinnerSelector != null) {
          this.stickyButton.classList.add(window.deployerAdapter.loadingClass);
          if (this.stickyButton.querySelector(window.deployerAdapter.loadingSpinnerSelector)) {
            this.stickyButton.querySelector(window.deployerAdapter.loadingSpinnerSelector).classList.remove('hidden');
          }
        }
        this.originalBtn.click();
        setTimeout(() => {
          if (window.deployerAdapter.loadingClass != null && window.deployerAdapter.loadingSpinnerSelector != null) {
            this.stickyButton.classList.remove(window.deployerAdapter.loadingClass);
            if (this.stickyButton.querySelector(window.deployerAdapter.loadingSpinnerSelector)) {
              this.stickyButton.querySelector(window.deployerAdapter.loadingSpinnerSelector).classList.add('hidden');
            }
          }
          this.stickyButton.removeAttribute('aria-disabled');
        }, 2000);
      }
    }
  );
}
